<!--
 * @Description: 公用的商户表单组件
 * @Author: sunhuihong
 * @Date: 2022-09-29 16:43:52
 * @LastEditTime: 2022-11-25 14:22:00
-->
<template>
  <div class="body">
    <el-form v-if="commonMchForm && commonMchForm.bankAccount && commonMchForm.merchant"  :model="commonMchForm" ref="commonMchForm" 
      :rules="rules" class="common-mch-form" :label-position="labelPosition" >
      <el-form-item label="所属机构："  class="common-mch-form-item" prop="bankAccount.institutionId" >
        <el-select size="small" style="width: 100%" v-model="commonMchForm.bankAccount.institutionId"  placeholder="请输入/选择"  filterable  
          clearable  :filter-method="(value) => commonUtil.handleListFilter(value, 'institutionsList', srcInstitutionList, this)"
					@visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible, 'institutionsList', srcInstitutionList, this)"
          @change="changeInst" :disabled="mode == 'edit' ? true  : false">
          <el-option v-for="item in institutionsList" :key="item.id" :label="item.name"  :value="parseInt(item.id)">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商户简称："  class="common-mch-form-item" prop="merchant.name">
        <el-input size="small" v-model.trim="commonMchForm.merchant.name" maxlength="21" placeholder="请输入商户简称"></el-input>
      </el-form-item>
      <div class="common-mch-form-item" v-if="mchFormData && mchFormData.typeMap">
        <div class="toggle-mch-type">
          <span :class="commonMchForm.merchant.type == key ? 'active' : 'click-switch-list'" @click="changeMerchantType(key)" 
            v-for="(item,key) in mchFormData.typeMap" :key="key">
            {{item}}
          </span>
        </div>
      </div>
      <div class="common-merchant-form">
        <!-- 营业执照信息模块 -->
        <div class="section-item" v-if="commonMchForm.merchant.type == 1">
          <div class="section-item-head">
		        <div class="blue-line"></div>
		    	  <span>营业执照信息</span>
		      </div>   
          <el-form-item class="common-mch-form-item" prop="merchant.bizLicenseImgPath" >
            <span slot="label" style="display: flex;">
              <span style="color: #606266; font-size: 14px; width: 115px;">营业执照扫描件：</span>
              <span style="color: #ACACAC; font-size: 12px; flex: 1;">
                请上传彩色照片 or 彩色扫描件 or 加盖公章鲜章的复印件，可新增微信支付相关水印（如微信支付认证）图片宽度不小于600像素的图片，
                图片大小不超过5M，支持上传png、jpg、jpeg
              </span>
	          </span>
            <el-upload class="certificates-uploader" ref="bizLicenseImgPath" multiple accept="image/jpeg,image/jpg,image/png" action="" 
              :show-file-list="false" :auto-upload="false" :on-change="handleAddBizLicenseImgPath">
              <el-image v-if="!bizLicenseFile && !commonMchForm.merchant.bizLicenseImgPath" class="bizLicenseImgPath-img" 
                :src="bizLicenseImgPath" fit="contain">
              </el-image>
              <div v-else style="width: 91px; height: 59px;">
                <el-image class="bizLicenseImgPath-img-file" :src="bizLicenseImgPath" fit="contain"></el-image>
                <span class="upload-hover">点击更换图片</span>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="证件注册号："  class="common-mch-form-item" prop="merchant.bizLicenseNo" >
            <el-input size="small" maxlength="18" v-model.trim="commonMchForm.merchant.bizLicenseNo" 
              placeholder="请输入证件注册号，须为18位数字|大写字母">
            </el-input>
          </el-form-item>
          <el-form-item label="商户名称："  class="common-mch-form-item" prop="merchant.fullname" >
            <el-input size="small" v-model.trim="commonMchForm.merchant.fullname" minlength="2" maxlength="40" 
              @input="inputFullname()" placeholder="请填写营业执照/登记证书的商家名称，2-40个字符，支持括号">
            </el-input>
          </el-form-item>
        </div>
        <!--法人身份信息模块  -->
        <div class="section-item">
          <div class="section-item-head">
		        <div class="blue-line"></div>
		    	  <span>{{commonMchForm.merchant.type == 1 ? '法人身份信息' : '经营者身份信息'}}</span>
		      </div> 
          <el-form-item label="证件类型："  class="common-mch-form-item" prop="merchant.idCardType" >
		    		<el-select size="small" style="width: 100%" v-model="commonMchForm.merchant.idCardType" filterable 
              placeholder="中国大陆居民-身份证">
		    			<el-option v-for="(item, key) in mchFormData.idCardTypeMap" :key="key" :label="item" :value="Number(key)" >
              </el-option>
		    		</el-select>
          </el-form-item>
          <el-form-item  class="common-mch-form-item" prop="merchant.idCardImg1Path" >
            <span slot="label" style="display: flex;">
              <span style="color: #606266; font-size: 14px; width: 115px;">身份证人像照片：</span>
              <span style="color: #ACACAC; font-size: 12px; flex: 1">
                请上传彩色照片 or 彩色扫描件 or 加盖公章鲜章的复印件，可新增微信支付相关水印（如微信支付认证）图片宽度不小于600像素的图片，
                图片大小不超过5M，支持上传png、jpg、jpeg
              </span>
	          </span>
            <el-upload class="certificates-uploader" ref="idCardImg1Path" multiple accept="image/jpeg,image/jpg,image/png" action="" 
              :show-file-list="false" :auto-upload="false" :on-change="handleAddIdCardImg1Path">
              <el-image v-if="!idCardImg1File && !commonMchForm.merchant.idCardImg1Path" class="idCard-img" 
                :src="idCardImg1Path" fit="contain">
              </el-image>
              <div v-else style="width: 91px; height: 59px;">
                <el-image class="bizLicenseImgPath-img-file" :src="idCardImg1Path" fit="contain"></el-image>
                <span class="upload-hover">点击更换图片</span>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item class="common-mch-form-item" prop="merchant.idCardImg2Path">
            <span slot="label" style="display: flex;">
              <span style="color: #606266; font-size: 14px; width: 115px;">身份证国徽照片：</span>
              <span style="color: #ACACAC; font-size: 12px; flex: 1">
                请上传彩色照片 or 彩色扫描件 or 加盖公章鲜章的复印件，可新增微信支付相关水印（如微信支付认证）图片宽度不小于600像素的图片，
                图片大小不超过5M，支持上传png、jpg、jpeg
              </span>
	          </span>
            <el-upload class="certificates-uploader" ref="idCardImg2Path" multiple accept="image/jpeg,image/jpg,image/png" action="" 
              :show-file-list="false" :auto-upload="false" :on-change="handleAddIdCardImg2Path">
              <el-image v-if="!idCardImg2File && !commonMchForm.merchant.idCardImg2Path" class="idCard-img" 
                :src="idCardImg2Path" fit="contain">
              </el-image>
              <div v-else style="width: 91px; height: 59px;">
                <el-image class="bizLicenseImgPath-img-file" :src="idCardImg2Path" fit="contain"></el-image>
                <span class="upload-hover">点击更换图片</span>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="身份证姓名："  class="common-mch-form-item" prop="merchant.idCardName"  >
            <el-input size="small" v-model.trim="commonMchForm.merchant.idCardName" 
              placeholder="请输入经营者/法定代表人对应身份证姓名" 
              @input="inputIdCardName()"  oninput="if(value.length > 30) value = value.slice(0, 30)">
            </el-input>
          </el-form-item>
          <el-form-item label="身份证号码："  class="common-mch-form-item" prop="merchant.idCardNo" >
            <el-input size="small" v-model.trim="commonMchForm.merchant.idCardNo" 
              placeholder="请输入经营者/法定代表人对应身份证号码"
              maxlength="18">
            </el-input>
          </el-form-item>
          <el-form-item label="身份证居住地址："  class="common-mch-form-item" prop="merchant.idCardAddr" >
            <el-input size="small" v-model.trim="commonMchForm.merchant.idCardAddr" 
              placeholder="请输入经营者/法定代表人对应身份证居住地址" 
              maxlength="70">
            </el-input>
          </el-form-item>
          <el-form-item label="身份证有效期：" ref="idCardValidtyLongTerm"  class="common-mch-form-item" 
            prop="merchant.idCardValidtyLongTerm" >
	  		  	<el-date-picker style="width: 203px"  size="small" v-model="commonMchForm.merchant.idCardValidtyStart" type="date" 
	  		  		align="center" placeholder="开始时间" :clearable="false"  format = 'yyyy-MM-dd' value-format = 'yyyy-MM-dd' >
          	</el-date-picker>
	  		  	<el-date-picker style="width: 203px; margin-left: 10px;" size="small" v-model="commonMchForm.merchant.idCardValidtyEnd" 
              type="date" align="center" placeholder="结束时间"  :clearable="false"  format = 'yyyy-MM-dd' value-format = 'yyyy-MM-dd' 
              @input="inputIdCardEndTime" :disabled="commonMchForm.merchant.idCardValidtyLongTerm == 1 ? true : false">
          	</el-date-picker>
            <el-checkbox v-model="commonMchForm.merchant.idCardValidtyLongTerm" :true-label="1" :false-label="0" 
              style="margin-left: 27px;" @change="changeIsLongTerm">
              长期有效
            </el-checkbox>
          </el-form-item>
          <el-form-item label="是否为受益人："  class="common-mch-form-item" >
            <el-radio v-model="commonMchForm.merchant.isOwner" :label="commonMchForm.merchant.isOwner" >是</el-radio>
          </el-form-item>
        </div>
        <!-- 结算银行账户模块 -->
        <div class="section-item" >
          <div class="section-item-head">
		        <div class="blue-line"></div>
	  	    	<span>结算银行账户</span>
		      </div>
          <el-form-item label="账户类型："  class="common-mch-form-item" >
            <el-radio v-model="commonMchForm.bankAccount.type" :label='commonMchForm.bankAccount.type' >
              {{commonMchForm.bankAccount.type == 1 ? '对公账户' : '对私账户'}}
            </el-radio>
          </el-form-item>
          <el-form-item label="开户银行："  class="common-mch-form-item" prop="bankAccount.bankName" >
		    		<el-select size="small" style="width: 100%" v-model="commonMchForm.bankAccount.bankName" filterable  clearable
              @change="handleBankName" 
              :filter-method="(value) => commonUtil.handleListFilter(value, 'bankList', srcBankList, this)"
					    @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible, 'bankList', srcBankList, this)" 
              placeholder="请输入/选择">
		    			<el-option v-for="item in bankList" :key="item.bankAliasCode" :label="item.name" :value="item.name" >
              </el-option>
		    		</el-select>
          </el-form-item>
          <el-form-item v-if="needBankBranch == 'true' " label="开户银行全称(含支行)："  class="common-mch-form-item" prop="bankAccount.bankFullname" >
            <el-row  type="flex" :gutter="20" justify="space-between">
              <el-col :span="7">
                <el-select size="small" v-model="commonMchForm.bankAccount.bankProvince" placeholder="请输入/选择省份"  filterable 
                  @change="handleProvince" 
                  :filter-method="(value) => commonUtil.handleListFilter(value, 'provinceList', srcProvinceList, this)"
					        @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible, 'provinceList', srcProvinceList, this)"
                  style="width: 100%"> 
                 <el-option v-for="item in provinceList" :key="item.code" :label="item.name"  :value="item.name" >
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="7">
                <el-select size="small" v-model="commonMchForm.bankAccount.bankCity" placeholder="请输入/选择市"  filterable 
                  @change="handleCity" 
                  :filter-method="(value) => commonUtil.handleListFilter(value, 'cityList', srcCityList, this)"
					        @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible, 'cityList', srcCityList, this)"
                  style="width: 100%">
                  <el-option v-for="item in cityList" :key="item.code" :label="item.name" :value="item.name" >
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="10">
                <el-select size="small" v-model="commonMchForm.bankAccount.bankFullname" placeholder="请输入/选择开户银行全称" filterable 
                  @change="handleBankFullname"
                  :filter-method="(value) => commonUtil.handleListFilter(value, 'branchesList', srcBranchesList, this)"
					        @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible, 'branchesList', srcBranchesList, this)"
                  style="width: 100%">
                 <el-option v-for="item in branchesList" :key="item.code" :label="item.name" :value="item.name" />
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="开户名称："  class="common-mch-form-item" >
            <el-input size="small" maxlength="40" disabled v-model="commonMchForm.bankAccount.accountName" 
              :placeholder="commonMchForm.merchant.type == 1 ? '与商户名称名称一致' : '与身份证姓名一致'">
            </el-input>
          </el-form-item>
          <el-form-item label="开户银行省市编码(行政区划代码)：" style=" position: relative;"  class="common-mch-form-item" prop="bankAccount.regionCode" >
            <el-input size="small" maxlength="12" v-model.trim="commonMchForm.bankAccount.regionCode" 
              placeholder="请输入开户银行省市编码(行政区划代码)" @input="inputRegionCode">
            </el-input>
            <a class="template-download" :href="provinceCityHref" download>
              <i class="el-icon-download" style="margin-right: 3px; font-size: 24px; vertical-align: middle;"/>
              点击下载《省市区编号对照表》
            </a>
            <el-alert v-show="includeRegionCode && this.commonMchForm.bankAccount.regionCode" 
              :title="regionCodeTips" 
              type="success" 
              :closable="false" show-icon>
            </el-alert>           
          </el-form-item>
          <el-form-item label="银行账号："  class="common-mch-form-item" prop="bankAccount.accountNo" >
            <el-input size="small" maxlength="30" v-model.trim="commonMchForm.bankAccount.accountNo" 
              placeholder="请输入银行账号">
            </el-input>
          </el-form-item>
        </div>
        <!-- 超级管理员信息模块 -->
        <div class="section-item">
          <div class="section-item-head">
		        <div class="blue-line"></div>
		    	  <span>超级管理员信息</span>
		      </div>
          <el-form-item label="超级管理员类型："  class="common-mch-form-item" >
            <el-radio v-model="commonMchForm.merchant.superAdminType" :label="commonMchForm.merchant.superAdminType" >
              {{commonMchForm.merchant.type == 1 ? '法人' : '经营者'}}
            </el-radio>
          </el-form-item>
          <el-form-item label="超级管理员手机："  class="common-mch-form-item" prop="merchant.superAdminMobile" >
            <el-input size="small" v-model.trim="commonMchForm.merchant.superAdminMobile" placeholder="请输入超级管理员手机号"
              maxlength="11" @input="inputSuperAdminMobile()">
            </el-input>
          </el-form-item>
          <el-form-item  label="超级管理员邮箱："  class="common-mch-form-item"  
            :rules="[{required: commonMchForm.merchant.type == 1 ? true : false, validator: validateEmail, trigger: 'blur'}]"
            prop="merchant.superAdminEmail" >
            <el-input size="small" v-model.trim="commonMchForm.merchant.superAdminEmail" maxlength="70"
              placeholder="请输入超级管理员邮箱">
            </el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="bk-wizard-bottons common-mch-button">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary"  @click.stop="handleSubmit('commonMchForm')">提 交</el-button>
    </div>
  </div>
</template>

<script>
import Util from '@/global/Util.js'
import Constant from '@/global/Constant.js'
import mchStore from './MchStore'

export default {
  name: 'CommonMchForm',
  mchStore,
  data() {
	  let validateMobile = (_rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!this.commonUtil.validateMobile(value)) {
		  	callback(new Error('请输入正确的手机号码'));
		  } else {
				callback();
			}
		};

	  let validateBizLicenseNo = (_rule, value, callback) => {
      if (this.commonMchForm.merchant.bizLicenseNo == '') {
        callback(new Error('请输入证件注册号'));
      } else if (!Util.validateBizLicenseNo(value)) {
		  	callback(new Error('证件注册号须为18位数字|大写字母'));
		  } else {
				callback();
			}
		};

		let validateIdNo = (_rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入真实身份证号'));
			} else if (value.length != 18 || !this.commonUtil.validateIdCardNo(value)) {
				callback(new Error('请输入正确的身份证号'));
			} else {
				callback();
			}
    };

		let validateIdCardValidtyLongTerm = (_rule, value, callback) => {
			if (value == 0 && this.commonMchForm.merchant.idCardValidtyEnd == null && 
        this.commonMchForm.merchant.idCardValidtyStart == null) {
        callback(new Error('请输入身份证有效期'));
      } else if (this.commonMchForm.merchant.idCardValidtyStart == null) {
        callback(new Error('请输入身份证开始时间'));
      } else if ((Date.parse(this.commonMchForm.merchant.idCardValidtyStart) > new Date().valueOf()) ) {
        callback(new Error('开始时间不能大于当前时间！'));
      } else if ((value == 0 && this.commonMchForm.merchant.idCardValidtyEnd == null) || 
        (value == 0 && this.commonMchForm.merchant.idCardValidtyEnd == '')) {
        callback(new Error('请输入身份证结束时间'));
      } else if (Date.parse(this.commonMchForm.merchant.idCardValidtyStart) >= 
        Date.parse(this.commonMchForm.merchant.idCardValidtyEnd)) {
        callback(new Error("结束时间必须大于开始时间！"))
      } else if ((new Date().valueOf()) >= Date.parse(this.commonMchForm.merchant.idCardValidtyEnd)) {
        callback(new Error("结束时间必须大于当前时间！"))
      } else {
        callback();
      }
    };

		let validateBizLeImgPath = (_rule, _value, callback) => {
			if (!this.bizLicenseImgPath || this.bizLicenseImgPath == require('@/assets/common/icon-common-camera.png')) {
        callback(new Error('请上传营业执照扫描件'));
      } else {
        callback();
      }
    };

		let validateIdCardImg1Path = (_rule, _value, callback) => {
			if (!this.idCardImg1Path || this.idCardImg1Path == require('@/assets/common/img-common-idcardback.png')) {
        callback(new Error('请上传身份证人像照片'));
      } else {
        callback();
      }
    };

    let validateIdCardImg2Path = (_rule, _value, callback) => {
			if (!this.idCardImg2Path || this.idCardImg2Path == require('@/assets/common/img-common-idcardfront.png')) {
        callback(new Error('请上传身份证国徽照片'));
      } else {
        callback();
      }
    };

    let validateRegionCode = (_rule, value, callback) => {
			if (!value) {
        callback(new Error('请输入开户银行省市编码'));
      } else if(this.includeRegionCode == '') {
        callback(new Error('请输入正确的开户银行省市编码'));
      } else {
        callback();
      }
    };

    let validateBankFullname = (_rule, value, callback) => {
			if (this.commonMchForm.bankAccount.bankProvinceCode == '') {
        callback(new Error('请输入/选择省份'));
      } else if (this.commonMchForm.bankAccount.bankCityCode == '') {
        callback(new Error('请输入/选择市'));
      } else if (!value) {
        callback(new Error('请输入/选择开户银行全称'));
      } else {
        callback();
      }
    };

    return {
      provinceCityHref: Constant.URL_PROVINCE_CITY_XLSX,//省市区编码对照表
      labelPosition: 'top',
      bankList: [],//银行列表
      institutionsList: [],//机构列表
      provinceList: [],//省份列表
      cityList: [],//城市列表
      branchesList: [],//支行列表
      rules: {
        'bankAccount': {
          institutionId: [{required: true, message: '请选择所属机构', trigger: 'blur' }],
          bankName: [{required: true, message: '请选择开户银行', trigger: 'blur' }],
          regionCode: [{required: true, validator: validateRegionCode, trigger: 'blur' }],
          bankFullname: [{required: true, validator: validateBankFullname, trigger: 'blur' }],
          accountNo: [{required: true, message: '请输入银行账号', trigger: 'blur' }],
        },
        'merchant': {
          name: [{required: true, message: '请输入商户简称', trigger: 'blur' }],
          bizLicenseImgPath: [{required: true, validator: validateBizLeImgPath, trigger: 'blur' }],
          bizLicenseNo: [{required: true, validator: validateBizLicenseNo, trigger: 'blur' }],
          fullname: [
            {required: true, message: '请输入商户名称', trigger: 'blur' },
            {min:2, max: 40, message: '输入商户名称字数应在2-40之间'}
          ],
          idCardType: [{required: true, message: '请选择证件类型', trigger: 'blur' }],
          idCardImg1Path: [{required: true, validator: validateIdCardImg1Path, trigger: 'blur' }],
          idCardImg2Path: [{required: true, validator: validateIdCardImg2Path, trigger: 'blur' }],
          idCardName: [{required: true, message: '请输入身份证姓名', trigger: 'blur' }],
          idCardNo: [{required: true, validator: validateIdNo, trigger: 'blur' }],
          idCardAddr: [{required: true, message: '请输入身份证居住地址', trigger: 'blur' }],
          idCardValidtyLongTerm: [{required: true, validator: validateIdCardValidtyLongTerm, trigger: 'blur' }],
          superAdminMobile: [{required: true, validator: validateMobile, trigger: 'blur' }],
        },
      },
      imgLimitation: {
        maxSize: Constant.LIMIT_IMG_SIZE_5,
        maxWidth: 600.0,
        maxHeight: 0,
        extLimit: {
          limitType: 2,
          minRatio: 0.1,
          minRatioText: '100:10'
        },
        returnData: {}
      },

      bankAliasCode: '',//银行别名编码
      privinceName: '',//省名字
      bankCityName: '',//城市名字
      regionCodeTips: '',//开户银行省市编码提示词
      includeRegionCode: null,
      needBankBranch: 'true',//是否显示省，市，支行一行
    }
  },

  computed : { 
    mode() {
      return mchStore.state.mode;
    },

    mchFormData() {
      this.clearData();
      this.institutionsList = mchStore.state.mchFormData.institutionList;
      this.getListProvince();
      return mchStore.state.mchFormData;
    },

    commonMchForm () {
      return mchStore.state.commonMchForm;
    },
    
    srcInstitutionList() {
      return mchStore.state.mchFormData.institutionList;
    },

    srcBankList() {
      let bankListMap = mchStore.state.mchFormData.bankListMap;
      if (this.commonMchForm.merchant.type == 1) {
        this.bankList = bankListMap.corporateBankList;
        return bankListMap.corporateBankList;
      } else if (this.commonMchForm.merchant.type == 2) {
        this.bankList = bankListMap.personalBankList;
        return bankListMap.personalBankList;
      }  
    },

    srcProvinceList() {
      this.provinceList = mchStore.state.srcProvinceList;
      return mchStore.state.srcProvinceList;
    },

    srcCityList() {
      this.cityList = mchStore.state.srcCityList;
      return mchStore.state.srcCityList;
    },

    srcBranchesList() {
      this.branchesList = mchStore.state.srcBranchesList;
      return mchStore.state.srcBranchesList;
    },

    bizLicenseFile() {
      return mchStore.state.bizLicenseFile ? mchStore.state.bizLicenseFile : null;
    },

    bizLicenseImgPath() {
      if (mchStore.state.bizLicenseFile) {
        return this.commonUtil.file2Url(mchStore.state.bizLicenseFile);
      } else if (this.commonMchForm.merchant.bizLicenseImgPath) {
        return this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, 
          this.commonMchForm.merchant.bizLicenseImgPath);
      } else {
        return require('@/assets/common/icon-common-camera.png');
      }
    },

    idCardImg1File() {
      return mchStore.state.idCardImg1File ? mchStore.state.idCardImg1File : null;
    },

    idCardImg1Path() {
      if (mchStore.state.idCardImg1File) {
        return this.commonUtil.file2Url(mchStore.state.idCardImg1File);
      } else if (this.commonMchForm.merchant.idCardImg1Path) {
        return this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, 
          this.commonMchForm.merchant.idCardImg1Path);
      } else {
        return require('@/assets/common/img-common-idcardback.png');
      }
    },

    idCardImg2File() {
      return mchStore.state.idCardImg2File ? mchStore.state.idCardImg2File : null;
    },

    idCardImg2Path() {
      if (mchStore.state.idCardImg2File) {
        return this.commonUtil.file2Url(mchStore.state.idCardImg2File);
      } else if (this.commonMchForm.merchant.idCardImg2Path) {
        return this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, 
          this.commonMchForm.merchant.idCardImg2Path);
      } else {
        return require('@/assets/common/img-common-idcardfront.png');
      }
    },
  },

  methods: {
    //选择机构
    changeInst(val) {
      this.commonMchForm.merchant.institutionId = val;
    },

    //选择开户银行
    handleBankName(value) {
      this.commonMchForm.bankAccount.ecmAccountbank = Util.searchKeyWithValueInArr('name', value, this.bankList).accountBank;
      this.queryNeedBankBranch(value);
      this.commonMchForm.bankAccount.bankFullname = '';
      this.bankAliasCode = Util.searchKeyWithValueInArr('name', value, this.bankList).bankAliasCode;
      this.commonMchForm.bankAccount.bankNameCode = this.bankAliasCode;
      if (this.needBankBranch == "false") return;
      this.requsetBranchesList(this.commonMchForm.bankAccount.bankCityCode, this.bankAliasCode);
    },

    //获取省数据
    getListProvince() {
      this.appAxios("GET", Constant.URL_GET_LIST_PROVINCES).then(result => {
        if (result == null) {
          return;
        }
        if (this.mode == 'edit' && this.srcBankList) {
          this.queryNeedBankBranch(this.commonMchForm.bankAccount.bankName);
        }
        mchStore.commit('changeSrcProvinceList', result.data);
      });
    },

    queryNeedBankBranch(value) {
      this.needBankBranch = Util.searchKeyWithValueInArr('name', value, this.srcBankList).needBankBranch;
    },

    //选择省
    handleProvince(value) {
      this.commonMchForm.bankAccount.bankCityCode = "";
      this.commonMchForm.bankAccount.bankCity = "";
      this.commonMchForm.bankAccount.bankFullname = "";
      this.commonMchForm.bankAccount.bankProvinceCode = Util.searchKeyWithValueInArr('name', value, this.provinceList).code;
      this.requsetCityList(this.commonMchForm.bankAccount.bankProvinceCode);
    },

    //请求市数据
    requsetCityList(privinceCode) {
      let url = this.commonUtil.fillUrlArgments(Constant.URL_GET_LIST_CITIES, privinceCode);
      this.appAxios("GET", url).then(result => {
        if (result == null) {
          return;
        }
        mchStore.commit('changeSrcCityList', result.data);
      });
    },

    //选择市
    handleCity(value) {
      this.$forceUpdate();
      this.commonMchForm.bankAccount.bankFullname = "";
      this.commonMchForm.bankAccount.bankCityCode = Util.searchKeyWithValueInArr('name', value, this.cityList).code;
      this.requsetBranchesList(this.commonMchForm.bankAccount.bankCityCode, this.bankAliasCode);
    },

    //请求支行列表数据
    requsetBranchesList(cityCode, bankAliasCode) {
      if (typeof cityCode !== 'string' || typeof bankAliasCode !== 'number') {
        return;
      }
      let params = {
        bankAliasCode: bankAliasCode,
        cityCode: cityCode
      };
      this.appAxios("GET", Constant.URL_GET_LIST_BRANCHES, params).then(result => {
        if (result == null) {
          return;
        }
        mchStore.commit('changeSrcBranchesList', result.data);
      });
    },

    //选择开户银行全称
    handleBankFullname(value) {
      this.$forceUpdate();
      this.commonMchForm.bankAccount.branchId = Util.searchKeyWithValueInArr('name', value, this.srcBranchesList).code;
    },

    //输入开户银行省市编码（只能输入数字，最长12位）
    inputRegionCode() {
			this.commonMchForm.bankAccount.regionCode = 
        this.commonUtil.filterDigitals(this.commonMchForm.bankAccount.regionCode);
			if (this.commonMchForm.bankAccount.regionCode.length > 12) {
				this.commonMchForm.bankAccount.regionCode = this.commonMchForm.bankAccount.regionCode.slice(0, 12);
			}
      this.queryIncludeRegionCode(this.commonMchForm.bankAccount.regionCode);
    },

    queryIncludeRegionCode(regionCode) {
      if (regionCode == '') {
        this.includeRegionCode = null;
        this.regionCodeTips = '';
        return;
      }
      let url = this.commonUtil.fillUrlArgments(Constant.URL_GET_COMMON_CFG_REGION, regionCode);
      this.appAxios("GET", url).then(result => {
        if (result == null) {
          return;
        }
        this.includeRegionCode = result.data;
        this.regionCodeTips = result.data == '' ? '' : regionCode + result.data;
        this.commonMchForm.bankAccount.regionDetail = result.data == '' ? regionCode : regionCode + result.data;
      });
    },
    
    //验证超级管理员邮箱
	  validateEmail(_rule, value, callback) {
      if (!value && this.commonMchForm.merchant.type == 1) {
        callback(new Error('请输入邮箱'));
      } else if (!Util.validateEmail(value) && this.commonMchForm.merchant.type == 1) {
		  	callback(new Error('请输入合法的邮箱'));
		  } else if (this.commonMchForm.merchant.type == 2 && value && !Util.validateEmail(value)) {
		  	callback(new Error('请输入合法的邮箱'));
		  } else {
				callback();
			}
		},

    //切换收付通商户类型（小微/企业）
    changeMerchantType (val) {
      this.commonMchForm.merchant.type = val;
      this.commonMchForm.bankAccount.type = val;
      this.commonMchForm.merchant.superAdminType = val;
      if (this.commonMchForm.merchant.type == 1) {
        this.commonMchForm.bankAccount.accountName = this.commonMchForm.merchant.fullname;
      } else if (this.commonMchForm.merchant.type == 2) {
        this.commonMchForm.bankAccount.accountName = this.commonMchForm.merchant.idCardName;
      } else {
        this.commonMchForm.bankAccount.accountName = '';
      }
      this.clearVaild();
    },

    //身份证是否长期有效(点击长期有效，开始时间与结束时间都清空且禁用)
    changeIsLongTerm(val) {
      if (val == 1) {
        this.commonMchForm.merchant.idCardValidtyEnd = '';
      }
      if (val == 1 && this.commonMchForm.merchant.idCardValidtyStart !== '') {
        this.$refs['idCardValidtyLongTerm'].clearValidate();
      }
    },

    //选择结束时间
    inputIdCardEndTime(val) {
      this.$set(this.commonMchForm.merchant,'idCardValidtyEnd',val);
      this.$forceUpdate();
    },

    //输入商户名称
    inputFullname() {
      if(this.commonMchForm.merchant.fullname.length > 40) {
				this.commonMchForm.merchant.fullname = this.commonMchForm.merchant.fullname.slice(0, 40);
			}
      if (this.commonMchForm.merchant.type == 1) {
        this.commonMchForm.bankAccount.accountName = this.commonMchForm.merchant.fullname;
      }
    },

    //输入身份证名
    inputIdCardName() {
      if (this.commonMchForm.merchant.type == 2) {
        this.commonMchForm.bankAccount.accountName = this.commonMchForm.merchant.idCardName;
      }
    },

    // 商户名称只能输入汉字、数字、中文英文的括号
    handleFullname(str,containBrackets) {
      return Util.filterChineseAndDigitalsAndBrackets(str, containBrackets);
    },

    //输入超级管理员手机号
    inputSuperAdminMobile() {
      this.commonMchForm.merchant.superAdminMobile = 
        this.commonUtil.filterDigitals(this.commonMchForm.merchant.superAdminMobile, ['-']);
    },

    //选择证件扫描件
    handleAddBizLicenseImgPath(file, _fileList) {
      this.imgUtil.validateAndCompressImg(file, this.imgLimitation).then((data) => {
        if (data.errorText && data.errorText.length) {
          this.$message.error(data.errorText);
        } else {
          mchStore.commit('changeBizLicenseFile', data.file);
        }
      })
    },

    //改变身份证人像照片
    handleAddIdCardImg1Path(file, _fileList) {
			this.imgUtil.validateAndCompressImg(file, this.imgLimitation).then((data) => {
				if (data.errorText && data.errorText.length) {
					this.$message.error(data.errorText);
				} else {
					mchStore.commit('changeIdCardImg1File', data.file);
				}
			})
    },

    //改变身份证国徽照片
    handleAddIdCardImg2Path(file, _fileList) {
			this.imgUtil.validateAndCompressImg(file, this.imgLimitation).then((data) => {
				if (data.errorText && data.errorText.length) {
					this.$message.error(data.errorText);
				} else {
					mchStore.commit('changeIdCardImg2Path', data.file);
				}
			})
    },

    getBankNameDetail() {
      if (this.needBankBranch == "false") return;
      let provinceDetails = this.commonMchForm.bankAccount.bankProvince + this.commonMchForm.bankAccount.bankProvinceCode;
      let cityDetails = this.commonMchForm.bankAccount.bankCity + this.commonMchForm.bankAccount.bankCityCode;
      let bankFullname = this.commonMchForm.bankAccount.bankFullname;
      this.commonMchForm.bankAccount.bankNameDetail =  provinceDetails + ',' + cityDetails + ',' + bankFullname;
    },

    //提交
    handleSubmit(commonMchForm) {
      this.$refs[commonMchForm].validate((valid) => {
        if (!valid) return;
        this.getBankNameDetail();
        this.$emit("close-drawer", true);
      })   
    },

    //取消
    handleClose() {
      this.clearVaild();
      this.$emit("close-drawer", false);
    },

    clearVaild() {
    	this.$nextTick(() => {
        this.$refs["commonMchForm"].clearValidate();
      });
		},

    clearData() {
      this.bankAliasCode = '';
      this.regionCodeTips = '';
      this.includeRegionCode = null;
    },
  },

  destroyed() {
    //销毁的时候同步数据
    mchStore.commit('changeCommonMchForm', this.commonMchForm);
  },
}
</script>
<style>
.common-mch-form .common-mch-form-item .el-form-item__label {
  line-height: 20px;
  padding: 0;
  margin-bottom: 10px;
} 

.common-mch-form .common-mch-form-item .el-upload {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.common-mch-form .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  float: left !important;
}

.common-mch-form .common-mch-form-item .el-alert {
  background-color: transparent;
  padding: 0;
}
</style>
<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.common-mch-form {
  text-align: left;
  margin-bottom: 38px;
}

.common-mch-button {
  text-align: center;
}

.common-mch-form-item {
  margin: 30px 135px 0 125px;
}

.toggle-mch-type {
  height: 32px;
  line-height: 32px;
}

.common-mch-form .active {
  display: inline-block;
  width: 120px;
  height: 100%;
  text-align: center;
  background-color:  #3E7EF5;
  color: #FFFFFF;
  cursor:pointer;
}

.common-mch-form .click-switch-list {
  display: inline-block;
  width: 120px;
  height: 100%;
  text-align: center;
  color: #B6BDCE;
  cursor:pointer;
}

.toggle-mch-type span:nth-child(1) {
  border: 1px solid #D7DDE5;
  border-radius: 4px 0 0 4px;
  border-right: none;
}

.toggle-mch-type span:nth-child(2) {
  border: 1px solid #D7DDE5;
  border-radius: 0 4px 4px 0;
}

.common-merchant-form {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.common-merchant-form .section-item {
  margin-top: 30px;
  text-align: left;
}

.common-merchant-form .section-item-head {
  display: flex;
  align-items: center;
  margin: 0 50px;
  text-align: left;
}

.common-merchant-form .section-item-head span {
  font-size: 14px;
  color: #657180;
}

.common-merchant-form .blue-line {
  width: 5px;
  height: 20px;
  border-radius: 2px;
  background: #3E7EF5;
  margin-right: 9px;
}

.certificates-uploader {
  position: relative;
  width: 91px;
  height: 59px;
  border-radius: 4px;
  border: 1px solid #D7DDE5;
  text-align: center;
  margin-top: -14px;
}

.bizLicenseImgPath-img {
  width: 26px;
  height: 25px;
}

.bizLicenseImgPath-img-file {
  width: 100%;
  height: 59px;
}

.idCard-img {
  width: 32px;
  height: 22px;
}

.el-upload:hover .upload-hover {
  display: block; 
}

.upload-hover {
  display: none;
  font-size: 8px;
  text-align: center;
  z-index: 200;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 91px;
  height: 59px;
  line-height: 59px;
  background: rgba(124,124,124,0.5500);
  font-weight: 600;
  color: #FFFFFF;
}

.region-code-msg {
  font-size: 12px;
}

.template-download {
  position: absolute;
  top: 0;
  right: 0;
  margin-right: -78px;
  margin-top: -40px;
  width: 300px;
  text-decoration: none;
  color: #409EFF;
}
</style>


// WEBPACK FOOTER //
// src/components/mchmng/components/CommonMchForm.vue